/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '0oa3myoy5WxJYD0RT356';
const ISSUER = process.env.REACT_APP_ISSUER || 'https://essilorext.okta.com/oauth2/default';
const CLIENT_ID_ADMIN = process.env.REACT_APP_CLIENT_ID_ADMIN || '0oa3myoy5WxJYD0RT356';
const ISSUER_ADMIN = process.env.REACT_APP_ISSUER_ADMIN || 'https://essilorext.okta.com/oauth2/default';
const IDP_ADMIN = process.env.REACT_APP_IDP_ADMIN || '0oa3myoy5WxJYD0RT356';
const config = {
    oidc: {
      issuer: ISSUER,
      clientId: CLIENT_ID,
      scopes: ['openid', 'profile', 'email'],
      redirectUri: `${window.location.origin}/login/callback`
    },
    widget: {
      issuer: ISSUER,
      clientId: CLIENT_ID,
      redirectUri: `${window.location.origin}/login/callback`,
      scopes: ['openid', 'profile', 'email'],
      useInteractionCodeFlow: false
    },
    admin: {
      issuer: ISSUER_ADMIN,
      clientId: CLIENT_ID_ADMIN,
      scopes: ['openid', 'profile', 'email'],
      redirectUri: `${window.location.origin}/login/callback`,
      idp: IDP_ADMIN,
    }
};

export default config;
